var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleColor = function SvgGoogleColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.773 12.267c0-.708.12-1.386.335-2.022L2.356 7.44a10.698 10.698 0 0 0-1.143 4.826 10.7 10.7 0 0 0 1.142 4.822l3.75-2.81a6.32 6.32 0 0 1-.332-2.012z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.36 5.83c1.57 0 2.99.544 4.104 1.436l3.242-3.17c-1.976-1.683-4.509-2.723-7.346-2.723-4.405 0-8.19 2.466-10.004 6.068l3.752 2.803C6.972 7.677 9.436 5.83 12.36 5.83z",
    fill: "#EB4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.36 18.704c-2.924 0-5.388-1.847-6.252-4.415l-3.752 2.803C4.17 20.695 7.955 23.16 12.36 23.16c2.719 0 5.314-.945 7.262-2.715l-3.56-2.694c-1.005.62-2.27.953-3.702.953z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.267a8.83 8.83 0 0 0-.253-1.98H12.36v4.208h5.979c-.3 1.435-1.113 2.538-2.277 3.256l3.56 2.694C21.67 18.586 23 15.818 23 12.267z",
    fill: "#4285F4"
  })));
};
export default SvgGoogleColor;